import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { User } from '../../../shared/models/user/User';
import { catchError, switchMap, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import * as localStorageConstants from '../../../../constants/local-storage-variables';
import { CompanyService } from '../company/company.service';
import { IAccount } from 'src/app/shared/models/interaction/iAccount';
import { EnvironmentResolveService } from '../environment-resolve/environment-resolve.service';
import { TICKET_FEATURES } from '../../../../constants/local-storage-variables';
import { IFeatures } from 'src/app/shared/models/interaction/iFeatures';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private ticketFeatures;
  private preserveLocalStorage = [
    localStorageConstants.WELCOME_PAGE,
    localStorageConstants.LANGUAGE
  ];

  constructor(
    private http: HttpClient,
    private router: Router,
    private companyService: CompanyService,
    private erService: EnvironmentResolveService) {}

  public signin(loginName: string, password: string, keepSignedIn: boolean): Observable<User> {
    const body = {
      loginName,
      password
    };

    return this.http.post(this.erService.environmentERS.apiUrlLogin, body).pipe(
      map((user: User) => {
        // if (keepSignedIn) {
        //   localStorage.setItem(localStorageConstants.ACCESS_TOKEN, user.accessToken);
        // }
        localStorage.setItem(localStorageConstants.ACCESS_TOKEN, user.accessToken);
        localStorage.setItem(localStorageConstants.USER_NAME, user.displayName);
        localStorage.setItem(localStorageConstants.GET_SUPPORT_KEYUSER_LOGIN, user.loginName);
        return user;
      }),
      catchError((error: any, caught: Observable<User>) => {
        return throwError(error);
      })
    );
  }

  public signOut() {
    // QUESTION: isn't this same as localStorage.clear()
    Object.keys(localStorageConstants).forEach(k => {
      if (! this.preserveLocalStorage.includes(localStorageConstants[k])) {
        switch (Object.prototype.toString.call(localStorageConstants[k])) {
          case '[object Object]':
            Object.keys(localStorageConstants[k]).forEach(ok => {
              localStorage.removeItem(localStorageConstants[k][ok]);
            });
            break;

          default:
            localStorage.removeItem(localStorageConstants[k]);
            break;
        }
      }
    });

    if (this.erService.environmentERS && this.erService.environmentERS.authMethod === 'NIAS') {
      window.location.href = '/live20/index.php?method=Tinebase.logoutSaml';
    } else {
      this.router.navigate(['login']);
    }
  }

  public getCurrentUser(): User {
    const id = localStorage.getItem(localStorageConstants.USER_ID);
    const contactId = localStorage.getItem(localStorageConstants.USER_CONTACT_ID);
    const displayName = localStorage.getItem(localStorageConstants.USER_NAME);
    const accessToken = localStorage.getItem(localStorageConstants.ACCESS_TOKEN);
    const loginName = localStorage.getItem(localStorageConstants.USER_LOGIN);
    const [lastName, firstName] = displayName.split(',').map(item => item.trim());
    return new User({
      id,
      contactId,
      loginName,
      firstName,
      lastName,
      displayName,
      accessToken,
      avatar: firstName.substring(0, 1).toUpperCase()
    });
  }

  public getFeatures(): Observable<IFeatures> {
    if (localStorage.getItem(localStorageConstants.TICKET_FEATURES)) {
      const ticketFeatures = localStorage.getItem(localStorageConstants.TICKET_FEATURES);
      return of({ features: ticketFeatures });
    }

    const body = {
      application: 'Tinebase',
      method: 'getFeatures',
      parameters: { 0: 'CPM' }
    };

    return this.http.post(this.erService.environmentERS.apiUrl, body).pipe(
      map((result: { features }) => {
        const ticketFeature = JSON.stringify(result.features.value ? result.features.value : {});
        localStorage.setItem(localStorageConstants.TICKET_FEATURES, ticketFeature);
        return { features: ticketFeature };
      })
    );
  }

  public getAccountInfo(): Observable<IAccount> {
    if (
      localStorage.getItem(localStorageConstants.USER_ID) &&
      localStorage.getItem(localStorageConstants.USER_CONTACT_ID)
    ) {
      return of({
        contactId: localStorage.getItem(localStorageConstants.USER_CONTACT_ID),
        accountId: localStorage.getItem(localStorageConstants.USER_ID),
        accountDisplayName: localStorage.getItem(localStorageConstants.USER_NAME)
      });
    }

    const body = {
      application: 'Tinebase',
      method: 'getRegistryData',
      parameters: { basic: true }
    };
    return this.http.post(this.erService.environmentERS.apiUrl, body).pipe(
      map((result: { currentAccount, config, defaultLang, companies }) => {
        localStorage.setItem(localStorageConstants.USER_CONTACT_ID, result.currentAccount.contact_id);
        localStorage.setItem(localStorageConstants.USER_COMPANIES, JSON.stringify(result.companies ? result.companies : {}));
        localStorage.setItem(localStorageConstants.USER_ID, result.currentAccount.accountId);
        localStorage.setItem(localStorageConstants.USER_NAME, result.currentAccount.accountDisplayName);
        localStorage.setItem(localStorageConstants.CUSTOMER_PORTAL_CONFIG, JSON.stringify(result.config.customerPortalConfig ? result.config.customerPortalConfig.value : {}));
        localStorage.setItem(localStorageConstants.DEFAULT_LANG, (result.defaultLang ? result.defaultLang : ''));
        return {
          contactId: result.currentAccount.contact_id,
          accountId: result.currentAccount.accountId,
          accountDisplayName: result.currentAccount.accountDisplayName
        };
      })
    );
  }
}
